module.exports = __webpack_public_path__ + "img/icon-visa.ae8ee406.svg";